<template>
  <section
    class="max-w-screen-xl mx-auto px-4 pb-20 max-md:pb-10 relative z-10"
  >
    <h2 class="text-center">
      <WrGradientText
        text="Privacy Policy"
        append-class="pb-0 pt-0 lg:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_35.57%,_var(--text-gradient-2)_55.72%)]"
      />
    </h2>
  </section>
  <section class="py-12 max-sm:pt-0 relative z-10">
    <div
      class="flex flex-col items-start justify-center w-full px-10 max-w-screen-xl mx-auto relative z-10"
    >
      <p class="text-lg max-md:text-sm">
        Please read our privacy policy carefully to get a clear understanding of
        how we collect, use, protect or otherwise handle your Personally
        Identifiable Information in accordance with our website.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Thank you for visiting
        <a
          href="https://webreinvent.com/"
          target="_blank"
          class="underline break-all hover:text-[#5f4ca4]"
          >www.webreinvent.com</a
        >
        (together with its content, subdomains, software available for download,
        tools and services, the (“Site”), which is operated by WebReinvent
        Technologies Pvt. Ltd. Your privacy is important to us. To better
        protect your privacy, we provide this privacy policy (“Privacy Policy”)
        explaining our online information practices and the choices you can make
        about the way your information is collected and used at this Site.
      </p>
      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        What personal information do we collect from the people that visit our
        blog, website, or app?
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        We collect your information to provide a better service and also improve
        our services. Usage of our services is considered as consent for
        collecting and using your information under our policy. When ordering or
        registering on our site, as appropriate, you may be asked to enter your
        details to help you with your experience. Personal data may be used to
        identify or contact you. These data may include but id not limited to:
      </p>
      <ul class="mt-5 text-lg max-md:text-sm list-[disc] pl-8 ml-8">
        <li v-for="item in personalInformation" class="mt-2">{{ item }}</li>
      </ul>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        When do we collect information?
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        We collect information from you when you subscribe to a newsletter, fill
        out a form, or enter information on our site. If you contact us
        directly, we may receive additional information such as the contents of
        the message and/or attachments you may send us, and any other
        information you may choose to provide.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        We may collect information from a third-party. Say for example, if we
        have integrated a feature which enables you to login from social media.
        Then the Third-party social media will provide us certain information
        which may include but are not limited to First name, Last name, email
        address, etc.
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        How do we use this information?
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        We may use the information we collect from you when you register, make a
        purchase, sign up for our newsletter, respond to a survey or marketing
        communication, surf the website, or use certain other site features in
        the following ways:
      </p>
      <ol class="mt-5 text-lg max-md:text-sm list-decimal ml-6">
        <li v-for="item in informationUsage" class="mt-4">{{ item }}</li>
      </ol>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        How do we protect visitor information?
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Our website is scanned at regular intervals for security holes and known
        vulnerabilities to make your visit to our site as safe as possible.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Your personal information is contained behind secured networks and is
        only accessible by a limited number of persons who have special access
        rights to such systems, and are required to keep the information
        confidential. In addition, all sensitive/credit information you supply
        is encrypted via Secure Socket Layer (SSL) technology.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        We implement a variety of security measures when a user enters, submits,
        or accesses their information to maintain the safety of your personal
        information.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Please Note: Your data security is indispensable to us, but keep in mind
        that no electronic storage or method of internet transmission comes with
        100% security. As we follow all commercially accepted methods to
        safeguard your Personal Information, still we cannot provide a guarantee
        of complete security.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Further, all transactions are processed through a gateway provider and
        are not stored or processed on our servers.
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        Do we use "cookies"?
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Yes, we do. Like any other website, we also use cookies. Cookies are
        small files that a site or its service provider transfers to your
        computer's hard drive through your Web browser (if you allow) that
        enables the site's or service provider's systems to recognize your
        browser and capture and remember certain information including visitors'
        preferences, and the pages on the website that the visitor accessed or
        visited. For instance, we use cookies to help us remember and understand
        your preferences based on previous or current site activity, which
        enables us to provide you with improved services. Further, cookies help
        us to compile data about site traffic and interactions which enables us
        to offer better site experiences and tools in the future. We may also
        use trusted third-party services that track this information on our
        behalf.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        You can choose to have your computer warn you each time a cookie is
        being sent, or you can choose to turn off all cookies. You do this
        through your browser settings. Each browser is a little different, so
        look at your browser's Help menu to learn the correct way to modify your
        cookies.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Note: Below ways are just a reference and may change according to
        version and time.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Chrome: Chrome Browser menu -> Settings -> Privacy and Security ->
        Cookies and other site data.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Internet Explorer: Internet Explorer Browser menu -> Settings -> Cookies
        and site permissions.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Mozilla Firefox: Mozilla Firefox Browser menu -> Settings -> Privacy and
        Security -> Cookies and Site data.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Note: If you disable cookies, some features might get disabled and some
        of our services may not function properly.
      </p>
      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        Third-Party Disclosure
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        We do not sell, trade, or otherwise transfer your personally
        identifiable information to outside parties. Occasionally, at our
        discretion, we may include or offer third-party products or services on
        our website. These third-party sites have separate and independent
        privacy policies. We, therefore, have no responsibility or liability for
        the content and activities of these linked sites. Nonetheless, we seek
        to protect the integrity of our site and welcome any feedback about
        these sites.
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        Google Analytics
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Google Analytics is an analytics service which helps Google to report
        and track website traffic and service usage, This data is then shared
        with other services of Google. This data may be used by Google in its
        own advertising networks ads. To gather more data regarding Google’s
        privacy practice, please visit Privacy and Terms page of Google
        <NuxtLink
          class="underline break-all hover:text-[#5f4ca4]"
          to="https://policies.google.com/privacy?hl=e"
        >
          https://policies.google.com/privacy?hl=e
        </NuxtLink>
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Google's advertising requirements can be summed up by Google's
        Advertising Principles. They are put in place to provide a positive
        experience for users.
        <NuxtLink
          class="underline break-all hover:text-[#5f4ca4]"
          to="https://support.google.com/adwordspolicy/answer/1316548?hl=en"
        >
          https://support.google.com/adwordspolicy/answer/1316548?hl=en
        </NuxtLink>
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        Privacy of Children
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        One of our priorities is protection for children while using the
        internet. We encourage parents to monitor, observe, participate and
        guide their children while using the internet. We do not gather
        personally identifiable data knowingly from anyone whose age is under 18
        nor we specifically market our products and services to children's.
        Guardians and parents of children who are aware of the fact that their
        child has shared the Personal Data with us should contact us. When we
        come to know that we have gathered Personal Data of children without
        parental consent and verification, we take necessary steps to eradicate
        that data from our servers immediately.
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">CAN SPAM Act</h3>
      <p class="mt-5 text-lg max-md:text-sm">
        The CAN-SPAM Act is a law that sets the rules for commercial email,
        establishes requirements for commercial messages, gives recipients the
        right to have emails stopped from being sent to them, and spells out
        tough penalties for violations.
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        We collect your email address in order to:
      </p>
      <ul class="mt-5 text-lg max-md:text-sm list-[disc] ml-8">
        <li v-for="item in canSpamActList1" class="mt-2">{{ item }}</li>
      </ul>
      <p class="mt-5 text-lg max-md:text-sm">
        NOT use false, or misleading subjects or email addresses
      </p>
      <ul class="mt-5 text-lg max-md:text-sm list-[disc] ml-8">
        <li v-for="item in canSpamActList2" class="mt-2">{{ item }}</li>
      </ul>
      <p class="mt-5 text-lg max-md:text-sm">
        If at any time you would like to unsubscribe from receiving future
        emails, you can
      </p>
      <ul class="mt-5 text-lg max-md:text-sm list-[disc] ml-8">
        <li class="mt-2">
          Follow the instructions at the bottom of each email.
        </li>
      </ul>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        Updates or Changes to Privacy Policy
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        We may change or update our Privacy Policy at any time. We will try to
        keep you updated with the new changes through emails but we strongly
        encourage you to please review the privacy policy periodically for any
        alterations. These policies will be effective from the date and time
        they have been posted on our website.
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">
        Governing Law and Jurisdiction
      </h3>
      <p class="mt-5 text-lg max-md:text-sm">
        The terms and conditions of this Policy shall be governed by Indian
        Laws, and the courts in DELHI, shall only have exclusive jurisdiction to
        resolve/ adjudicate upon any disputes.
      </p>

      <h3 class="mt-5 text-[22px] max-md:text-lg font-bold">Contact Us</h3>
      <p class="mt-5 text-lg max-md:text-sm">
        Address: 2nd Floor, Plot 6, Apex Square 3, Pocket B 3, Sector 17,
        Dwarka, Delhi, India 110075
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Email:
        <a
          href="mailto:we@webreinvent.com"
          class="underline break-all hover:text-[#5f4ca4]"
          >we@webreinvent.com</a
        >
      </p>
      <p class="mt-5 text-lg max-md:text-sm">
        Contact no:
        <a
          href="tel:08588864948"
          class="underline break-all hover:text-[#5f4ca4]"
          >085888 64948</a
        >
      </p>
      <p class="mt-5 text-[10px]">*Effective date: September 14, 2010</p>
    </div>
  </section>

  <section
    class="relative pt-10 lg:pt-20 overflow-hidden max-w-screen-xl mx-auto px-4 z-20"
  >
    <h2 class="text-center mb-11">
      <WrGradientText text="Trusted for excellence and efficiency" />
      <span
        class="text-lg max-md:text-sm text-[var(--foreground)] font-anvtgrade-book block"
      >
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </span>
      <span
        class="text-lg max-md:text-sm text-[var(--foreground)] font-anvtgrade-book block"
      >
        Webreinvent is trusted by leading organisations to enhance their
        development and operational efficiency.
      </span>
    </h2>
    <!-- Carousel Section -->
    <WrTestimonialCardCarousel />
    <WrButton link="/testimonials" container-class="max-w-max mx-auto mt-7"
      >View All</WrButton
    >
  </section>
</template>

<script setup>
useHead({
  title: "Software Products, Web and Mobile App Development Company",
  meta: [
    { charset: "utf-8" },
    { name: "viewport", content: "width=device-width, initial-scale=1" },
    {
      name: "description",
      content:
        "Read WebReinvent’s Privacy Policy to understand how we collect, use, and protect your personal information. Learn about cookies, third-party disclosures, data security, children’s privacy, and your rights.",
    },
    {
      name: "keywords",
      content:
        "WebReinvent privacy policy, personal data protection, cookies policy, third-party disclosure, data security, children privacy, CAN SPAM Act, information usage",
    },
    { name: "twitter:card", content: "summary" },
    { name: "twitter:site", content: "@weinvent" },
    { name: "twitter:creator", content: "@weinvent" },
    {
      property: "og:title",
      content: "Software Products, Web and Mobile App Development Company",
    },
    {
      property: "og:description",
      content:
        "Read WebReinvent’s Privacy Policy to understand how we collect, use, and protect your personal information. Learn about cookies, third-party disclosures, data security, children’s privacy, and your rights.",
    },
    {
      property: "og:image",
      content: "https://webreinvent.com/images/social-sharing.webp",
    },
    {
      property: "og:image:secure_url",
      content: "https://webreinvent.com/images/social-sharing.webp",
    },
    { property: "og:image:alt", content: "WebReinvent" },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://webreinvent.com" },
    { property: "og:site_name", content: "WebReinvent" },
    { property: "fb:admins", content: "204425406249172" },
  ],
});

const personalInformation = ref([
  "First name",
  "Last name",
  "Email address",
  "Contact number",
  "Usage",
  "Cookies Data, etc.",
]);

const informationUsage = ref([
  "  Provide: User's experience plays a crucial part in today's competitive environment. We use your data to provide a better User experience and to deliver the type of content and product offerings in which you are most interested.",
  "Improve: To improve, personalize and expand our website to better serve you.",
  "Service: We use your data to better handle your service requests and provide you with the utmost quality resolutions.",
  "Inform: We like our users well informed. Therefore, we use your information to send you periodic emails regarding the updates and other information relating to the website or other products and services.",
]);

const canSpamActList1 = ref([
  "Send information, respond to inquiries, and/or other requests or questions.",
  "Market to our mailing list or continue to send emails to our clients after the original transaction has occurred",
  "To be accordance with CANSPAM we agree to the following:",
]);
const canSpamActList2 = ref([
  " Identify the message as an advertisement in some reasonable way",
  "Include the physical address of our business or site headquarters",
  "Monitor third party email marketing services for compliance, if one is used.",
  "Honor opt-out/unsubscribe requests quickly",
  "Allow users to unsubscribe by using the link at the bottom of each email",
]);
</script>
